/**
 * CDN placeholders for cards without a ЖК photo.
 * Replace these URLs after the three final images are uploaded.
 */
export const POPULAR_NEWBUILDING_PLACEHOLDER_IMAGE_URLS = [
  'https://static.cdn-cian.ru/frontend/collections-assets/mainpage/popular-newbuilding-placeholder-1.webp',
  'https://static.cdn-cian.ru/frontend/collections-assets/mainpage/popular-newbuilding-placeholder-2.webp',
  'https://static.cdn-cian.ru/frontend/collections-assets/mainpage/popular-newbuilding-placeholder-3.webp',
];

export const POPULAR_NEWBUILDING_CARDS_BEFORE_TABLET_BREAKPOINT = 5;
export const POPULAR_NEWBUILDING_CARDS_AFTER_TABLET_BREAKPOINT = 4;
